<mat-nav-list>
  <mat-list-item [routerLink]="['/home']">
    <div class="list-item">
      HOME
    </div>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item [routerLink]="['/example1']">
    <div class="list-item">
      Example 1
    </div>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item [routerLink]="['/example2']">
    <div class="list-item">
      Example 2
    </div>
  </mat-list-item>
  <mat-divider></mat-divider>
  <mat-list-item [routerLink]="['/example3']">
    <div class="list-item">
      Example 3
    </div>
  </mat-list-item>
  <mat-divider></mat-divider>
</mat-nav-list>
